module.exports = __webpack_public_path__ + "img/ylb-2.5b89b0ca.png";